import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { Link } from "react-router-dom";
//import NetBalance from './netbalance';

let netBalance;

class NetBalance extends Component {
  calculateNetBalance = (credit, debit) => {
    if (credit > 0) {
      netBalance = parseFloat(netBalance) - parseFloat(credit);
    } else {
      netBalance = parseFloat(netBalance) + parseFloat(debit);
    }

    let bal = parseFloat(netBalance).toFixed(2);

    if (bal < 0) {
      let bal1 = bal.replace("-", "");
      return "(" + parseFloat(bal1).toFixed(2) + ")";
    }
    return parseFloat(netBalance).toFixed(2);
  };

  render() {
    const { transactions, opening_balance, report, reportDate, type } =
      this.props;
    netBalance = parseFloat(opening_balance).toFixed(2);

    let openBal = 0;
    if (netBalance < 0) {
      const netBalance1 = netBalance.replace("-", "");
      openBal = "(" + netBalance1 + ")";
    }

    let url = "";
    const origin = "?origin=" + type;

    return (
      <Table celled fixed singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colspan="2">{report}</Table.HeaderCell>
            <Table.HeaderCell colspan="4" style={{ textAlign: "center" }}>
              Opening Balance:{openBal}
            </Table.HeaderCell>
            <Table.HeaderCell colspan="1" style={{ textAlign: "center" }}>
              Date: {reportDate}
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell width={2}>Date</Table.HeaderCell>
            <Table.HeaderCell width={3}>Account Name</Table.HeaderCell>
            <Table.HeaderCell width={2}>Account Type</Table.HeaderCell>
            <Table.HeaderCell width={5}>Description</Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: "center" }}>
              Debit
            </Table.HeaderCell>
            <Table.HeaderCell width={2} style={{ textAlign: "center" }}>
              Credit
            </Table.HeaderCell>
            <Table.HeaderCell width={2}>Net Balance</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {transactions.map((transaction) => (
            <Table.Row>
              <Table.Cell>{transaction.date}</Table.Cell>
              <Table.Cell style={{ whiteSpace: "pre-line" }}>
                {transaction.account == "Visas" ? (
                  <Link
                    to={"/visas-accounts/view/" + transaction.id + origin}
                    className="ui"
                  >
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Vehicles" ? (
                  <Link
                    to={"/vehicles-accounts/view/" + transaction.id + origin}
                    className="ui"
                  >
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Yards" ? (
                  <Link
                    to={"/yards-accounts/view/" + transaction.id + origin}
                    className="ui"
                  >
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Rooms" ? (
                  <Link
                    to={"/rooms-accounts/view/" + transaction.id + origin}
                    className="ui"
                  >
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Others Accounts" ? (
                  <Link to={"/accounts/view/" + transaction.id} className="ui">
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Projects" ? (
                  <Link
                    to={"/projects-accounts/view/" + transaction.id}
                    className="ui"
                  >
                    {transaction.account_name}
                  </Link>
                ) : (
                  ""
                )}
                {transaction.account == "Expense"
                  ? transaction.account_name
                  : ""}
              </Table.Cell>
              <Table.Cell>{transaction.account}</Table.Cell>
              <Table.Cell style={{ whiteSpace: "pre-line" }}>
                {transaction.description}
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center" }}>
                {transaction.debit}
              </Table.Cell>
              <Table.Cell style={{ textAlign: "center" }}>
                {transaction.credit}
              </Table.Cell>
              <Table.Cell>
                {this.calculateNetBalance(
                  transaction.credit,
                  transaction.debit
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }
}

export default NetBalance;
